module.exports = __webpack_public_path__ + "img/partners.8602de24.png";